import { contactInfo, contactObj } from "@/lib/contacts";
import { Link } from "@/navigation";
import React from "react";

export default function Follow() {
	let data = [
		{ icon: "ri-facebook-fill", link: contactObj.FaceBook },
		{ icon: "ri-instagram-line", link: contactObj.Instagram },
		{ icon: "ri-youtube-fill", link: contactObj.Youtube },
		{ icon: "ri-tiktok-fill", link: contactObj.Tiktok },
		{ icon: "ri-linkedin-fill", link: contactObj.Linkedin },
	];
	return (
		<div className="right-content flex items-center gap-5">
			{data.map((item, index) => (
				<Link key={index} href={item.link} target="_blank" className="flex items-center gap-2">
					<i className={`${item.icon} text-[25px] text-white`}></i>
				</Link>
			))}
		</div>
	);
}
